import { Box, Grid, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import _ from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import ModalComponent from '../../common/Modal/ModalComponent.js';
import Spinner2 from "../../common/Spinner/Spinner2";
import movementColorCode from '../../../../jsonStore/colorCode.json';
import moment from 'moment';
import { getMovement, fetchSavedView, baseUrl } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';
import { useSelector } from "react-redux";

const entity = "movement";
const odataApiName = "movements";
const odataApiNameFor = "movements"; // Future use if need to open as popup from any plan function
let service = getSetDataService();
let dataService = dataStorageService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'Table Rows', 'View Columns', 'Settings', 'Refresh', 'New Window'];
// const planRelatedAction = ['Plan On New Trip', 'Depot', 'Delete Depot', 'Hook Off', 'Delete Hook Off', 'Custom Hook Off', 'Report', 'Contract Out'];
const planRelatedAction = ['Plan On New Trip', 'Contract Out', 'Process Trips', 'Create Trips', 'Depot', 'Delete Depot', 'Report', 'Hook Off', 'Delete Hook Off', 'Custom Hook Off', 'Split Up', 'Regroup Movement', 'Create Separate Bookings', 'Create/Add Existing Bookings', 'View E-CMR', 'Create E-CMR', 'Print CMR', 'On Hold On/Off', 'Truck Appointment New', 'Truck Appointment Add To', 'Truck Appointment Overview', 'Insert Terminal', 'Delete Terminal', 'Postpone', 'Change Plan Department', 'Change Plan Subdepartment', 'Plan On Map'];
//#region SortData start

const Movements = (props) => {
  //#region Reference
  const movGridRef = useRef(null);
  //#endregion Reference

  //#region Hook Selctor

  let gridSelectedValues = {};

  //#endregion Hook Selctor

  const movGriddDtaItemKey = "id";
  const initialSort = service.initialSort[entity];
  const refTime = useSelector(state => state.refreshTime.refreshTime);
  const refreshMovement = useSelector(state => state.movement.refreshMovement);
  const plannedOnAgenda = useSelector(state => state.movement.plannedOnAgenda);
  const hasApiLoadedData = JSON.parse(dataService.getLocalStorageData("apiLoadedData"));
  const customActionsData = JSON.parse(dataService.getLocalStorageData('customActions')) || [];
  const customActionsMovements = customActionsData?.filter(action => action?.form === "Shipment Movements");
  //#region States - Get set variables
  const [colorCodeData, setColorCodeData] = useState();
  const [movGridColumnList, setMovGridColumnList] = useState(null);
  const [tempMovGridColumnList, setTempMovGridColumnList] = useState(null);

  const [tempMovementsData, setTempMovementsData] = useState([]);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const rowColorField = 'status';

  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [movMeasureFilter, setMovMeasureFilter] = React.useState();
  const [isShowmovements, setIsShowmovements] = useState(true);

  const [loadedGridData, setLoadedGridData] = useState([]);
  const [routeGuidesData, setRouteGuidesData] = useState([]);
  const [planDepartmentData, setPlanDepartmentData] = useState([]);
  const [planSubdepartmentData, setPlanSubdepartmentData] = useState([]);
  
  const [myGridData, setmyGridData] = React.useState([]);
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const currStatusValue = "0";
  const startDate = new Date();
  const days = 0;
  const statusData = [{ name: 'To Plan', caption: 'To Plan', value: '0' },
      { name: 'Planned', caption: 'Planned', value: '1' },
      { name: 'In Execution', caption: 'In Execution', value: '2' },
      { name: 'Executed', caption: 'Executed', value: '3' },
      { name: 'Not Executed', caption: 'Not Executed', value: '4' },
      { name: 'Cancelled', caption: 'Cancelled', value: '5' },
      { name: ' ', caption: ' ', value: ' ' }];
  const movDefaultFilters = [
    { type: 'DatePicker', key: 'startDate', value: startDate, label: 'Start Date', placeholder: 'Start date...' },
    { type: 'NumericTextBox', key: 'daysToShow', value: days, label: 'Days To Show', placeholder: 'Please enter value', relationalField: 'startDate' },
    { type: 'DropDownList', key: 'status', value: statusData[0], label: 'Status', data: statusData},
  ];
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [movFilterComponents, setMovFilterComponents] = useState(movDefaultFilters);
  const editableColumn = ['routeGuideCode', 'planInfo', 'planDepartment', 'planSubdepartment'];

  const [nextDataUrl, setNextDataUrl] = useState(null);
  const userID = localStorage.getItem('userID');
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [changeToChildMV, setChangeToChildMV] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [splitScreen, setSplitScreen] = useState(false);
  const [canExecute, setCanExecute] = useState([]);
  //#endregion States
  let refreshTime = JSON.parse(dataService.getLocalStorageData('refreshTime'))
  const metaData = JSON.parse(dataService.getLocalStorageData("metaData"))

  //#region Hooks

  useEffect(() => {
    // setIsLoading(true);

    const movColorCodeList = localStorage.getItem('movColorCodeList');
    if (_.isNil(movColorCodeList)) {
      getColorCode();
    } else {
      setColorCodeData(JSON.parse(movColorCodeList));
    }
    // if (!hasApiLoadedData) {  // Removed this to call it everytime as per requirement of alex in #1859
      getRouteGuides();
      getPlanDepartments();
      getPlanSubdepartments();
      dataService.setLocalStorageData("apiLoadedData", true);
    // }
    setIsApiLoaded(true);
    setTimeout(()=>{
      setGridColumns(entity);
    },100)

    let tempFilterData = [];
    if (days > 0) {
      tempFilterData.push({ field: 'startDate', value: service.dateFormat(startDate, 'startDate') + (days > 0 ? ".." + service.dateFormat(startDate, 'startDate', days) : ""), isLast: false, type: 'Edm.Date' });
    } else {
      tempFilterData.push({ field: 'startDate', value: ">=" + service.dateFormat(startDate, 'startDate'), isLast: false, type: 'Edm.Date' });
    }
    tempFilterData.push({ field: 'status', value: '=' + currStatusValue, isLast: false, type: 'Edm.String' });

    let userData = service.getUserFilterData(entity);
    const mergedArray = tempFilterData.concat(userData);
    setInitialFilter(mergedArray);

    localStorage.removeItem('measurementData');
    setRouteGuidesData(JSON.parse(dataService.getLocalStorageData('routeGuides')) || []);
    setPlanDepartmentData(JSON.parse(dataService.getLocalStorageData('planDepartments')) || []);
    setPlanSubdepartmentData(JSON.parse(dataService.getLocalStorageData('planSubdepartments')) || []);
  }, []);

  const getRouteGuides = () => {
    const url = `${baseUrl}/routeGuides`;
    apiService.get(url).then((response) => {
      setRouteGuidesData(response.value)
      dataService.setLocalStorageData('routeGuides', JSON.stringify(response.value));
    })
  }

  const getPlanDepartments = () => {
    const url = `${baseUrl}/departments?$filter=(planDepartment eq true)`;
    apiService.get(url).then((response) => {
      setPlanDepartmentData(response.value)
      dataService.setLocalStorageData('planDepartments', JSON.stringify(response.value));
    })
  }

  const getPlanSubdepartments = () => {
    const url = `${baseUrl}/subdepartments?$filter=(planSubdepartment eq true)`;
    apiService.get(url).then((response) => {
      setPlanSubdepartmentData(response.value)
      dataService.setLocalStorageData('planSubdepartments', JSON.stringify(response.value));
    })
  }

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityName + 'ColumnList');
    if (!_.isNil(columnList)) {
    const parseColumnList = JSON.parse(columnList);
    const statusColumn = parseColumnList?.find(column => column?.field?.toLowerCase() === 'status');
    if (statusColumn) {
    const tempMovFilterComponents = movFilterComponents;
    for (const movFilterComponent of tempMovFilterComponents) {
    if (movFilterComponent?.key === 'status') {
    movFilterComponent.data = statusColumn?.dropdownData;
    }
        }
        setMovFilterComponents(tempMovFilterComponents);
    }
      setMovMeasureFilter(JSON.parse(localStorage.getItem('movMeasureFilter')));
    setMovGridColumnList(JSON.parse(columnList));
    getColList(entity, JSON.parse(columnList));
    return true;
    }
    
    if(!_.isNil(metaData) || metaData !== "undefined") {
      const odataMetadata = metaData;
      const url = `${process.env.REACT_APP_COMMON_API_URL}entityDefinitions?$schemaversion=2.0&$filter=entityName eq '${entityName}'`;
      apiService.get(url).then(captionRes => {
        const odataCaptionMetadata = captionRes.value[0].properties;
        let tempFieldList = [];
        let measureField = [];
        const filteredData = odataMetadata.children[0].children[0].children.filter(e => e.name == 'EntityType' && e.attributes['Name'] == entityName);
        const dropdownData = odataMetadata.children[0].children[0].children.filter(e => e.name == 'EnumType')
        const enumCaptions = dataService.getLocalStorageData('enumCaptions') ? JSON.parse(dataService.getLocalStorageData('enumCaptions')) : [];
        filteredData[0].children.forEach(e => {
          const newdropDownData = dropdownData.filter(elem=> e.attributes['Type'] && e.attributes['Type'].endsWith(elem.attributes['Name']))
          let newArray = [], enumName = '';          
          if(newdropDownData.length > 0) {
            const entityEnumCaption = enumCaptions?.find(enumColumn => enumColumn.entityName === newdropDownData[0].attributes.Name);
            newArray = newdropDownData[0].children.map(item => {
              if(item.attributes.Name.replace("_x0020_"," ") == " "){
                  return {
                      name:" ",
                      value:" ",
                      caption:"All"
                  }
              }else{
                  return {
                      name: item.attributes.Name.replace("_x0020_"," "),
                      value: item.attributes.Name.replace("_x0020_"," ") !== " " ? item.attributes.Value : " ",
                      caption: entityEnumCaption?.values?.filter(value => value?.name === item?.attributes?.Name).map(x => x?.caption)[0] ? 
                          entityEnumCaption?.values?.filter(value => value?.name === item?.attributes?.Name).map(x => x?.caption)[0] : item?.attributes?.Name
                      }
              }
          });            
            enumName = newdropDownData[0]?.attributes?.Name;
          }
          if (e.attributes['Name'] === 'status') {
            const tempMovFilterComponents = movFilterComponents;
            for (const movFilterComponent of tempMovFilterComponents) {
              if (movFilterComponent?.key === 'status') {
                movFilterComponent.data = newArray;
              }
            }
            setMovFilterComponents(tempMovFilterComponents);
          }

          if (e.attributes['Type'] == 'Edm.Decimal') {
            const item = {
              field: e.attributes['Name'][0].toUpperCase() + e.attributes['Name'].slice(1),
              type: e.attributes['Type']
            }
            measureField.push(item);
          }
          if (e.name == 'Property') {
            const languageCode = localStorage.getItem("languageCode");
            const caption = odataCaptionMetadata.filter((elem) => elem.name === e.attributes['Name'])[0].captions.filter((elem) => elem.languageCode === parseInt(languageCode))[0]?.caption;
            const obj = {
              field: e.attributes['Name'],
              title: caption ? caption : e.attributes['Name'],
              type: e.attributes['Type'],
              enumName: enumName,
              enumField: enumName ? true : false,
              dropdownData : newArray,
              visible: true,
              width: 100,
              locked: false,
              order: 'asc',
              groupBy: false
            }
            tempFieldList.push(obj)
          }
        });
        let obj = {
          measureColumnsData: [],
          movMeasureTableColumns: measureField,
          draggedItem: {}
        }
        setMovMeasureFilter(obj);
        localStorage.setItem('movMeasureFilter', JSON.stringify(obj));

        tempFieldList.unshift({
          field: 'ActionColumn',
          title: 'Action',
          visible: true,
          width: 60,
          locked: false,
          order: 'asc',
          groupBy: false,
        });
        localStorage.setItem(entityName + 'ColumnList', JSON.stringify(tempFieldList));
        setMovGridColumnList(tempFieldList);
        getColList(entity, tempFieldList);
      })
      .catch(error => {
        console.log(error)
      })
    }
  }

  const getDefaultColList = (dcolsString, entityName, gridcolumns) => {
    if (!_.isNil(dcolsString) && dcolsString != "undefined") {
      const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
      const defaultColumnList = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field) || item.field == 'instructionsExist' || item.field == 'qualificationsExist' || item.field == 'ActionColumn'
      });
      if (defaultColumnList.length == 0) {
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempMovGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnList, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(sortedArr));
        setTempMovGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setMovGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempMovGridColumnList(gridcolumns);
    }
  }

  const getColList = (entityName, gridcolumns) => {
    const mvUrl = `${fetchSavedView}?$filter=(title eq '${odataApiName}' and userID eq '${userID}')`;
    const dcolsStringMV = localStorage.getItem("defaultColumnSetting");
    apiService.get(mvUrl).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResMV => {
          if (readResMV !== undefined && readResMV !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readResMV);
            const defaultViewExist = readResMV[odataApiName]?.savedViews?.filter(item => item.defaultView);
            setCanExecute(defaultViewExist);
            if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
              const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
              if (favFilterExist?.length > 0) {
                setTempMovGridColumnList(defaultViewExist[0].columns);
              }
            } else if (readResMV[odataApiName]?.columns?.length !== 0) {
              localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(readResMV[odataApiName]?.columns));
              setTempMovGridColumnList(readResMV[odataApiName]?.columns);
            } else {
              getDefaultColList(dcolsStringMV, entityName, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsStringMV, entityName, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true)
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempMovGridColumnList)) {
      setNextDataUrl(null)
      updateSendApi(loadSelectionValue);
    }
  }, [tempMovGridColumnList]);

  //#endregion Hooks

  //#region Methods

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsShowmovements(value);
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempMovGridColumnList(value.columns);
      setCanExecute([]);
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
    } else if (flag === 'columnsVisible') {
      setTempMovGridColumnList(value);
    }
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const closeConfirmationModal = (e, flag) => {
    setopenConfirmationModal(false);
    setErrorMessage(null);
    setCommonPopupParameters({});
  }


  const sendApi = (val, size, type =null) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (canExecute?.length > 0) {
      return;
    }
    if (tempMovGridColumnList?.length > 0) {
      if(type != "autoRefresh") {
        setIsLoading(true);
      }
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempMovGridColumnList?.filter(item => item.field !== 'instructionsExist' && item.field !== 'ActionColumn').map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }
      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      // if (size == 'All') {
      //   size = totalData
      // }
      apiService.get(getMovement,params, `${selectFields}`, oDataNextLink, size,null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveMV = response.error.message.split("'")[1];
            setChangeToChildMV({ type: "sort", value: sortToRemoveMV });
          } else if (response?.error?.code == "Application_FilterErrorException" || response?.error?.message?.includes('not filterable')) {
            const filterToRemoveMV = response.error.message.split("'")[1];
            setChangeToChildMV({ type: "filter", value: filterToRemoveMV });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);

            let tempData = [];
            if (val == 'Scroll' && tempMovementsData !== null && tempMovementsData !== undefined && tempMovementsData.length > 0) {
              tempMovementsData.forEach(tempMovement => {
                tempData.push(tempMovement);
              });
              response.value.map(temp => {                  
                tempData.push(temp)
              })
            } else {
              tempData = response.value;
            }
            tempData = setColorCodeAndDate(tempData);
            setIsApiLoaded(true);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }
            setmyGridData(tempData);
            setLoadedGridData(tempData);
            setTempMovementsData(tempData);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
          if (props?.sendDataToParent) {
            props.sendDataToParent(odataApiName);
          }
        });
    } else {
      setIsLoading(false);
    }
  }

  const sendApiForMovement = (rows) => {
    if (rows !== null && rows !== undefined && rows.length > 0) {
      let filter = rows && '$filter=(' + rows.filter(item => item.movementId).map(item => 'id eq ' + item.movementId).join(' or ') + ')';
      const params = '&' + filter;
      const columns = tempMovGridColumnList?.filter(item => item.field !== 'instructionsExist' && item.field !== 'ActionColumn').map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element);
          }
        });
      }
      const selectFields = `&$select=${columns}`;
      setIsLoading(true);
      apiService.get(getMovement, params, `${selectFields}`, null, null, null).then(response => {
        if (response.value !== null && response.value !== undefined && response.value.length > 0) {
          let tempData = loadedGridData;
          for (const movement of tempData) {
            const index = rows.findIndex(move => move.movementId === movement.id);
            if (index !== -1) {
              const resObject = response.value.find(resValue => resValue.id = movement.id);
              Object.keys(resObject).forEach((key) => {
                if (movement.hasOwnProperty(key)) {
                  movement[key] = resObject[key];
                }
              });
            }
          }
          tempData = setColorCodeAndDate(tempData);
          setmyGridData(tempData);
          setLoadedGridData(tempData);
          setTempMovementsData(tempData);
        } else {
          console.error("Response value is not available.");
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);

  const getColorCode = () => {
    setIsLoading(true);
    setColorCodeData(movementColorCode)

    // apiService.fetchStatusColorCodeData().then(response => {
    //   if (response && response.value) {
    //     setColorCodeData(response.value);
    //   } else {
    //     // console.error("Response or response.value is undefined");
    //   }
    // })
    //   .catch((error) => {
    //     console.log(error);
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   })
  }

  const setColorCodeAndDate = (arrList) => {
    // Need to Opetimize
    const dateColumns = tempMovGridColumnList?.filter(item => item.type === 'Edm.Date' || item.type === 'Edm.DateTimeOffset').map(item => item.field);
    const timeColumns = tempMovGridColumnList?.filter(x => (x.field.includes('Time') || x.field === 'shippingHour') && x.type === 'Edm.String').map(item => item.field);
    const enumColumns = movGridColumnList?.filter(field => field.enumField).map(item => ({
      field: item.field,
      enumName: item.enumName
    }));
    const enumCaptions = dataService.getLocalStorageData('enumCaptions') ? JSON.parse(dataService.getLocalStorageData('enumCaptions')) : [];
    arrList?.forEach(e => {
      let filterdObj = colorCodeData?.find(o => e[rowColorField] === o.movementStatus);
      if (!_.isEmpty(filterdObj)) {
        e.colorPlanningHex = filterdObj.colorPlanningHex;
        e.textColorPlanningHex = filterdObj.textColorPlanningHex;
      }

      timeColumns?.forEach(column => {
        if (e[column]) {
          e[column] = moment(e[column], 'HH:mm:ss').format('HH:mm');
        }
      });

      dateColumns?.forEach(column => {
        if (new Date(e[column]).getYear() < 0) {
          e[column] = '';
        } else {
          e[column] = new Date(e[column]);
        }
      })

      enumColumns?.forEach(column => {
        if (e[column.field]) {
          if (enumCaptions?.find(enumColumn => enumColumn?.entityName === column?.enumName)) {
            for (const caption of enumCaptions) {
              if (caption?.entityName === column?.enumName && caption?.values?.length > 0 && caption?.values?.filter(value => value?.name === e[column.field]).map(x => x?.caption)?.length > 0) {
                  e[column.field] = caption?.values?.filter(value => value.name === e[column.field]).map(x => x.caption)[0];
              }
            }
          }
        }
      })

    });
    return arrList;
  }

  // --- Common methods END ---

  //#endregion Methods

  //#region Not in use

  const onLoadSelectionChange = (e) => {
    let value = e.value;
    setloadSelectionValue(value);
    sendApi(null, value);
  }

  const onSplitScreenClick = (val) => {
    setSplitScreen(val);
  }

  //#endregion

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };
useEffect(()=>{  
  if(refreshMovement.isRefresh)
    sendApi(null, loadSelectionValue, "autoRefresh")
},[refreshMovement])
  useEffect(()=>{    
    if(refreshTime != null) {
      const fetchData = () => {
        // Your API call logic here
        sendApi(null, loadSelectionValue, "autoRefresh")
      };
  
      let intervalId = setInterval(fetchData, refreshTime * 1000);
      // Clean up the interval on component unmount
      return () => clearInterval(intervalId);
    }
  },[loadSelectionValue,tempMovGridColumnList,refreshTime,paramsData,refTime])

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

        <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose}
          isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose}
        />
        {isShowmovements &&
          <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Movements</Typography>
          </Box>}
        <Grid container sx={{ marginTop: 0 }} className='filterbar-bg'  >

          {!splitScreen &&

            <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
              {isApiLoaded && <DataGridComponent
                {...props}
                gridRef={movGridRef}
                gridFlagVal={odataApiName}
                gridFlagValFor={odataApiNameFor}
                gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
                entity={entity}
                loadedGridData={loadedGridData}
                gridNewData={myGridData}
                tempGridData={tempMovementsData}
                gridColumnList={movGridColumnList ? movGridColumnList : []}
                gridTempColumnList={tempMovGridColumnList ? tempMovGridColumnList : []}
                gridSort={initialSort}
                isItemVisible={true}
                isShowGridHeader={isShowmovements}
                griddDtaItemKey={movGriddDtaItemKey}
                onSplitScreenClick={onSplitScreenClick}
                sendDataToParent={childStateHandler}
                gridDataAction={dataRelatedAction}
                gridPlanAction={planRelatedAction}
                colorCode={colorCodeData}
                gridFilterComponents={movFilterComponents}
                gridDefaultFilters={movDefaultFilters}
                colorStatus={rowColorField}
                editableColumn={editableColumn}
                onsendApiForMovement={sendApiForMovement}
                onLoadSelectionChange={onLoadSelectionChange}
                loadSelectionValue={loadSelectionValue}
                gridMeasureFilter={movMeasureFilter}
                gridtotalData={totalData}
                routeGuidesData={routeGuidesData}
                planDepartmentData={planDepartmentData}
                planSubdepartmentData={planSubdepartmentData}
                gridInitialFilter={initialFilter}
                initialSaveViewData={initialSaveViewData}
                initialFetchReadLinkData={initialFetchReadLinkData}
                isLoading={isLoading}
                changeToChild={changeToChildMV}
                isDraggable={true}
                customActions={customActionsMovements}
              />}
            </Grid>}

          <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />

        </Grid>
      </Grid>
    </>
  )
};

export default Movements;